
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 0a12 12 0 1012 12A12 12 0 0012 0zm2.72 16.84a4.08 4.08 0 01-2.76.9 4.05 4.05 0 01-2.69-.87 2.88 2.88 0 01-1.04-2.33h1.9a1.59 1.59 0 00.5 1.22 1.91 1.91 0 001.35.47 1.97 1.97 0 001.4-.47 1.76 1.76 0 00.5-1.36 1.78 1.78 0 00-.53-1.38 2.28 2.28 0 00-1.58-.49h-1.11v-1.5h1.15a2.07 2.07 0 001.39-.45 1.62 1.62 0 00.51-1.29 1.76 1.76 0 00-.42-1.26 1.72 1.72 0 00-1.3-.45 1.81 1.81 0 00-1.26.44 1.48 1.48 0 00-.5 1.15h-1.9a2.87 2.87 0 01.47-1.59 3.12 3.12 0 011.3-1.12 4.22 4.22 0 011.86-.4 3.92 3.92 0 012.68.85 3 3 0 01.97 2.38 2.42 2.42 0 01-.49 1.44 3.06 3.06 0 01-1.26 1.02 2.8 2.8 0 011.43 1.01 2.76 2.76 0 01.49 1.64 3.06 3.06 0 01-1.06 2.44z"}})])
          )
        }
      }
    